import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import { useSalesDraftProvider } from '../Sales.Draft.Hooks';
import { combineStrings } from 'assets/utils/data/String';

export default function DraftDelete() {
  const { lang } = getLocales();
  const { deleteApi, draft, selected, pageRouter } = useSalesDraftProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={combineStrings('/', draft?.vehicle?.year?.toString(), draft?.vehicle?.makeCode, draft?.vehicle?.model)}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
